import DeviceDetector from "device-detector-js";
import store from '@/store';
import { network } from './network';
import { getBaseInviteCode } from '@/utils/util';

const deviceDetector = new DeviceDetector();
const deviceInfo = deviceDetector.parse(window.navigator.userAgent);

export async function report(opts) {
	let inviteCode = store.state.user.inviteCode;
	const { VUE_APP_ENVIRONMENT } = window.APP_ENV;

	if (VUE_APP_ENVIRONMENT !== 'online') {
		return;
	}

	if (!inviteCode) {
		inviteCode = getBaseInviteCode();
	}

	const res = await network({
		url: 'https://report.akaliai.com/api/data_report',
		method: 'post',
		params: {
			...opts,
			invite_code: inviteCode,
			extra_data: JSON.stringify({
				url: window.location.href,
				os: deviceInfo.os.name
			})
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}